import { render, staticRenderFns } from "./LogisticLeadTimeEvents.vue?vue&type=template&id=e6883690&scoped=true&"
import script from "./LogisticLeadTimeEvents.vue?vue&type=script&lang=js&"
export * from "./LogisticLeadTimeEvents.vue?vue&type=script&lang=js&"
import style0 from "./LogisticLeadTimeEvents.vue?vue&type=style&index=0&id=e6883690&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6883690",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCard,VCol,VDivider,VListItemAvatar,VRow})
